import { createStart } from "@tanstack/react-start";
import { requestGuard } from "./middleware";

export const startInstance = createStart(() => ({
  requestMiddleware: [requestGuard],
}));
